import React from 'react';
import type { FunctionComponent } from 'react';
import { differenceInDaysHandler, longDateHandler } from '@utils';

interface RemovedStatusProps {
	removedOnUtc: string;
}

export const RemovedStatus: FunctionComponent<RemovedStatusProps> = ({ removedOnUtc }) => {
	return (
		<div className="account-status-tooltip">
			<p className="account-status-content-row account-status-content-row--bold">Removed on:</p>
			<p className="account-status-content-row">{longDateHandler(removedOnUtc)}</p>
			<p className="account-status-content-row">{differenceInDaysHandler(removedOnUtc)} days ago</p>
		</div>
	);
};
